import { Button, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { hasPermission } from 'common/access-control';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { IRootState } from 'reducers';

const useStyles = makeStyles(theme => ({
  root: {},
  title: {},
  row: {
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1)
  },
  spacer: {
    flexGrow: 1
  },
  importButton: {
    marginRight: theme.spacing(1)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  searchInput: {
    marginRight: theme.spacing(1)
  }
}));

const UsersToolbar = (props: any) => {
  const { className, matchingClient, ...rest } = props;
  const { langPropertyStock: lang } = useSelector((state: IRootState) => state.locale);
  const classes = useStyles();
  const history = useHistory();

  const { privileges } = useSelector((state: IRootState) => state.login);
  const canCreateUnownedPropertyStock = hasPermission(privileges, 'CREATE', 'UNOWNED_PROPERTY_STOCK');
  const canCreateCompanyPropertyStock = hasPermission(privileges, 'CREATE', 'COMPANY_STOCK');
  const canCreateOwnPropertyStock = hasPermission(privileges, 'CREATE', 'OWN_PROPERTY_STOCK');
  const canReadUnownedClient = hasPermission(privileges, 'READ', 'UNOWNED_CLIENT');

  const showCreatePsButton = canCreateCompanyPropertyStock || canCreateOwnPropertyStock || (canCreateUnownedPropertyStock && canReadUnownedClient);

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <div className={classes.row}>
        <Typography
          className={classes.title}
          variant="h2"
        >
          {lang.titlePropertySearch}
        </Typography>
        <span className={classes.spacer} />
        {/* <Button className={classes.importButton}>Import</Button>
        <Button className={classes.exportButton}>Export</Button> */}
        {showCreatePsButton ?
          <Button
            color="primary"
            variant="contained"

            onClick={() => history.push('/properties/new')}
          >
            {lang.actionNewPropertyStock}
          </Button>
          : null}
      </div>
      {/* <div className={classes.row}>
        <SearchInput
          className={classes.searchInput}
          placeholder="Search user"
        />
      </div> */}
    </div>
  );
};

UsersToolbar.propTypes = {
  className: PropTypes.string
};

export default UsersToolbar;
